import * as React from "react";
import "./dropDownWrapper.scss";
import classNames = require("classnames");

interface IProps {
	/**
	 * Wrapper width.
	 */
	width?: number | string;
	/**
	 * On outside click callback
	 */
	onOutsideClick?: (evt: Event) => void;
	/**
	 * Indicates if dropdown should be rendered on top of the element.
	 */
	dropDownTop?: boolean;

	autoWidth?: boolean;
}

interface IState {
	/**
	 * Indicates if dropdown should be rendered on top of the element.
	 */
	dropDownTop: boolean;
}

export default class DropDownWrapper extends React.Component<IProps, IState> {

	public static defaultProps: Partial<IProps> = {
		width: 260
	};

	dropDownWrapper: HTMLDivElement;

	constructor(props: IProps) {
		super(props);
		this.state = {
			dropDownTop: false
		};
		this.handleOutsideClick = this.handleOutsideClick.bind(this);
	}

	componentDidMount() {
		document.addEventListener("mousedown", this.handleOutsideClick);
		// iOS Safari sends no mousedown for a tap on something that is not clickable, so a tap beside the list
		// would leave it open.
		document.addEventListener("touchstart", this.handleOutsideClick);
		this.setState({
			dropDownTop: this.props.dropDownTop || this.dropDownWrapper.parentElement.getBoundingClientRect().top + 50 >
			window.innerHeight - this.dropDownWrapper.getBoundingClientRect().height
		});
	}

	componentWillUnmount() {
		document.removeEventListener('mousedown', this.handleOutsideClick);
		document.removeEventListener('touchstart', this.handleOutsideClick);
	}

	render() {

		const classFromProps = classNames({
			"m-dropdown-wrapper": true,
			"is-top": this.state.dropDownTop
		});

		return (
			<div ref={(ddw) => this.dropDownWrapper = ddw}
				 className={classFromProps}
				 style={this.props.autoWidth ? {width: "100%"} : {width: this.props.width instanceof String ? this.props.width : `${this.props.width}px`}}>
				{this.props.children}
			</div>
		);
	}

	/**
	 * Handle click outside dropdown list.
	 */
	handleOutsideClick(evt: Event) {
		if (this.dropDownWrapper && !this.dropDownWrapper.contains(evt.target as HTMLElement)) {
			this.props.onOutsideClick && this.props.onOutsideClick(evt);
		}
	}
}
